var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0077b5",
    d: "M43 21.5a21.5 21.5 0 1 1-43.01-.01A21.5 21.5 0 0 1 43 21.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.5 12c-1.42 0-2.5 1.04-2.5 2.34 0 1.3 1.07 2.41 2.5 2.41 1.47 0 2.5-1.12 2.5-2.41v-.01A2.44 2.44 0 0 0 15.5 12zm0 1c.97 0 1.45.54 1.5 1.36-.01.81-.48 1.39-1.5 1.39-.97 0-1.5-.61-1.5-1.41 0-.8.52-1.34 1.5-1.34zm-2.09 4a.51.51 0 0 0-.41.5V29c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V17.5a.5.5 0 0 0-.5-.5h-4.09zm5.5 0a.51.51 0 0 0-.41.5V29c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-6.5c0-.2.07-.64.25-.95.18-.32.41-.55 1-.55.7 0 .9.25 1.06.56.16.32.19.73.19.94V29c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-6.5c0-1.77-.52-3.16-1.41-4.09A4.63 4.63 0 0 0 26.16 17a4.4 4.4 0 0 0-2.66.81v-.31a.5.5 0 0 0-.5-.5h-4.09zM14 18h3v10.5h-3zm5.5 0h3v1.05c0 .22.16.42.38.47a.5.5 0 0 0 .56-.24s.14-.28.56-.61a3.36 3.36 0 0 1 2.16-.67c1.08 0 2.01.37 2.7 1.09.69.73 1.14 1.83 1.14 3.41v6h-3v-6c0-.24-.01-.82-.3-1.39A2.12 2.12 0 0 0 24.75 20c-.91 0-1.56.5-1.87 1.05-.32.54-.38 1.1-.38 1.45v6h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.091156d6fcf03263419716cb5cd6e24a.svg";
export { ForwardRef as ReactComponent };